
(()=>{'use strict';
 const money=c=>window.FlyWellNative.money(c);
 function showGalleryImage(src,alt){
  const gallery=document.querySelector('.fp-gallery-main');
  if(!gallery)return;
  gallery.src=src;gallery.alt=alt;
  const paired=src==='//drinkflywell.com/cdn/shop/t/47/assets/fw-v22-9a500d6554444600cc0658c6.webp?v=142836492165105336151791507256';
  const buttons=[...document.querySelectorAll('[data-gallery-src]')];
  const selected=buttons.find(b=>b.dataset.gallerySrc===src);
  const stage=document.querySelector('.fp-gallery-stage');
  if(stage)stage.style.aspectRatio=paired?'1':selected?.dataset.galleryAspect||'1';
  document.querySelector('.fp-gallery-media')?.classList.toggle('is-paired',paired);
  const stick=document.querySelector('.fp-gallery-stick');if(stick)stick.hidden=!paired;
  buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.gallerySrc===src)));
 }
 async function init(){
  const form=document.querySelector('[data-fp-product]');
  if(form){
   const product=await window.FlyWellNative.product(form.dataset.fpProduct);
   let galleryFlavor=null;
   function update(){
    const flavor=form.querySelector('[name=flavor]:checked').value,count=form.querySelector('[name=packet-count]:checked').value;
    form.querySelectorAll('.fp-flavors input').forEach((input,index)=>{
     const tile=input.closest('label'),flavorVariant=product.variants.find(v=>v.option1===input.value&&v.option2===count),unavailable=!flavorVariant?.available;
     let badge=tile.querySelector('.fp-flavor-stock');
     if(!badge&&unavailable){
      badge=document.createElement('small');badge.className='fp-flavor-stock';badge.id='fp-flavor-stock-'+index;badge.textContent='Out of Stock';tile.append(badge);
     }
     tile.classList.toggle('is-out-of-stock',unavailable);
     if(badge)badge.hidden=!unavailable;
     if(unavailable)input.setAttribute('aria-describedby',badge.id);else input.removeAttribute('aria-describedby');
    });
    const variant=product.variants.find(v=>v.option1===flavor&&v.option2===count),plan=form.querySelector('[name=delivery]:checked').value;
    if(!variant)return;form.elements.id.value=String(variant.id);form.querySelector('input[type=hidden][name=selling_plan]').value=plan;
    const subscription=variant.selling_plan_allocations?.find(a=>String(a.selling_plan_id)==='4046455090');
    form.querySelector('[data-one-price]').textContent=money(variant.price);form.querySelector('[data-sub-price]').textContent=money(subscription?.price??variant.price);
    form.querySelector('[data-selected-price]').textContent=money(plan&&subscription?subscription.price:variant.price);
    const subscriptionInput=form.querySelector('[name=delivery][value="4046455090"]'); if(subscriptionInput)subscriptionInput.disabled=!subscription; form.querySelector('[type=submit]').disabled=!variant.available||!!(plan&&!subscription);
    const label=form.querySelector('[data-add-label]'),status=form.querySelector('[data-product-status]');
    if(label)label.textContent=variant.available?'Add To Cart':'Sold out';
    if(status)status.textContent=variant.available?'':'This flavor is currently unavailable.';
    if(galleryFlavor!==null&&galleryFlavor!==flavor)showGalleryImage(flavor==='Passion Fruit Tangerine'?'//drinkflywell.com/cdn/shop/t/47/assets/fw-v22-9a500d6554444600cc0658c6.webp?v=142836492165105336151791507256':variant.featured_image?.src||product.featured_image,'FlyWell '+flavor);
    galleryFlavor=flavor;
   }
   form.addEventListener('change',update);update();
  }
  const overlay=document.getElementById('fw-modal-overlay');
  if(overlay){
   let returnFocus=null;
   new MutationObserver(()=>{if(overlay.classList.contains('open')){returnFocus=document.activeElement;overlay.querySelector('button')?.focus()}else returnFocus?.focus()}).observe(overlay,{attributes:true,attributeFilter:['class']});
   overlay.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();document.getElementById('fw-modal-close').click()}if(e.key==='Tab'){const nodes=[...overlay.querySelectorAll('button,input,select,a[href]')].filter(x=>!x.disabled&&x.getClientRects().length);const first=nodes[0],last=nodes.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}}});
  }
  document.querySelectorAll('[data-gallery-src]').forEach(button=>button.addEventListener('click',()=>{
   showGalleryImage(button.dataset.gallerySrc,button.querySelector('img').alt);
  }));
  document.querySelector('[data-review-open]')?.addEventListener('click',()=>{const f=document.querySelector('.fp-review-form');f.hidden=!f.hidden;if(!f.hidden)f.querySelector('input').focus()});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init().catch(console.error));else init().catch(console.error);
})();

/* Video controls initialize independently of the cart and product catalog. */
(()=>{'use strict';
 function initTravelerVideos(){
  const cards=[...document.querySelectorAll('.fp-ugc-video')];
  if(!cards.length)return;
  const videos=cards.map(card=>card.querySelector('video'));
  cards.forEach(card=>{
   const video=card.querySelector('video'),button=card.querySelector('[data-ugc-play]'),error=card.querySelector('.fp-ugc-error');
   button.hidden=false;
   button.addEventListener('click',()=>{
    error.hidden=true;
    if(video.error)video.load();
    const request=video.play();
    if(request)request.catch(()=>{button.hidden=false;error.hidden=false});
   });
   video.addEventListener('play',()=>{
    videos.forEach(other=>{if(other!==video)other.pause()});
    error.hidden=true;button.hidden=true;
   });
   video.addEventListener('pause',()=>{button.hidden=false});
   video.addEventListener('ended',()=>{button.hidden=false});
   video.addEventListener('error',()=>{button.hidden=false;error.hidden=false});
  });
  if('IntersectionObserver' in window){
   const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(!entry.isIntersecting)entry.target.pause()})},{threshold:0});
   videos.forEach(video=>observer.observe(video));
  }
  document.addEventListener('visibilitychange',()=>{if(document.hidden)videos.forEach(video=>video.pause())});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initTravelerVideos);else initTravelerVideos();
})();
